import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount, currency = 'AED') {
  return new Intl.NumberFormat('en-AE', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(amount || 0);
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-AE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleString('en-AE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getExpiryStatusClass(days) {
  if (days === null || days === undefined) return 'status-valid';
  if (days < 0) return 'status-expired';
  if (days <= 7) return 'status-critical';
  if (days <= 30) return 'status-warning';
  if (days <= 60) return 'status-upcoming';
  return 'status-valid';
}

export function getExpiryStatusLabel(days) {
  if (days === null || days === undefined) return 'Unknown';
  if (days < 0) return 'Expired';
  if (days <= 7) return 'Critical';
  if (days <= 30) return 'Warning';
  if (days <= 60) return 'Upcoming';
  return 'Valid';
}

export function getOrderStatusClass(status) {
  const classes = {
    'Draft': 'order-draft',
    'Pending': 'order-pending',
    'Documents Collected': 'order-pending',
    'Submitted': 'order-progress',
    'In Progress': 'order-progress',
    'Completed': 'order-completed',
    'Delivered': 'order-delivered',
    'Cancelled': 'status-expired',
    'On Hold': 'status-warning'
  };
  return classes[status] || 'order-draft';
}

export function getInvoiceStatusClass(status) {
  const classes = {
    'Draft': 'status-draft',
    'Sent': 'status-sent',
    'Viewed': 'status-sent',
    'Partially Paid': 'status-partial',
    'Paid': 'status-paid',
    'Overdue': 'status-overdue',
    'Cancelled': 'status-expired',
    'Refunded': 'status-warning'
  };
  return classes[status] || 'status-draft';
}
